import { dialogStore } from "@ucl/library";
import { TaskExecutionComponent } from "../TaskExecutionComponent/TaskExecutionComponent";
import { TaskExecutionModuleFormRegistry } from "../TaskExecutionModule/TaskExecutionModuleProps";
import { TaskExecutionModuleRegistry } from "../TaskExecutionModule/registry";
import { BoltTaskGridProps } from "../TaskGrid/TaskGrid";
import { CommentPermissions } from "../TaskExecutionComponent/TaskExecutionActivityFeed";

export interface OpenTaskExecutionDialogProps {
  taskId: string;
  apiBaseUrl: string;
  getAuthRequestHeader: () => Promise<Record<string, string> | undefined>;
  taskExecutionModuleRegistry?: TaskExecutionModuleRegistry;
  formRegistry?: TaskExecutionModuleFormRegistry;
  handleTaskComplete?: (taskId: string) => Promise<void>;
  onClose?: () => void;
  isTaskOverviewReadOnly?: boolean;
  leftPanelIsDocked?: boolean;
  rightPanelIsDocked?: boolean;
  // `relatedTasksConfig` is used to pass configuration to the related tasks view
  relatedTasksGridProps?: BoltTaskGridProps;
  showRelatedTasks?: boolean;
  commentPermissions?: CommentPermissions;
}

export const openTaskExecutionDialog = ({
  taskId,
  apiBaseUrl,
  getAuthRequestHeader,
  taskExecutionModuleRegistry,
  formRegistry,
  handleTaskComplete,
  onClose,
  isTaskOverviewReadOnly,
  leftPanelIsDocked,
  rightPanelIsDocked,
  relatedTasksGridProps,
  showRelatedTasks,
  commentPermissions,
}: OpenTaskExecutionDialogProps) => {
  const closeDialog = () => {
    dialogStore.closeDialog("task-execution-dialog");
  };
  const close = () => {
    onClose?.();
    closeDialog();
  };

  dialogStore.openDialog(
    {
      id: "task-execution-dialog",
      allowDragging: false,
      isFullScreen: true,
      content: () => (
        <TaskExecutionComponent
          taskId={taskId}
          customRegistry={taskExecutionModuleRegistry}
          onTaskComplete={async () => {
            await handleTaskComplete?.(taskId);
            closeDialog();
          }}
          onClose={close}
          apiBaseUrl={apiBaseUrl}
          getAuthRequestHeader={getAuthRequestHeader}
          formRegistry={formRegistry}
          isTaskOverviewReadOnly={isTaskOverviewReadOnly}
          leftPanelIsDocked={leftPanelIsDocked}
          rightPanelIsDocked={rightPanelIsDocked}
          relatedTasksGridProps={relatedTasksGridProps}
          showRelatedTasks={showRelatedTasks}
          commentPermissions={commentPermissions}
        />
      ),
      close,
    },
    true
  );
};
